/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Usage_Tab_Contract_UntilInputs */



/**
* | output |
* | --- |
* | "Contract until {date}" |
*
* @param {Usage_Tab_Contract_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_contract_until = /** @type {((inputs: Usage_Tab_Contract_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Contract_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vertrag bis ${i?.date}`)
	return /** @type {LocalizedString} */ (`Contract until ${i?.date}`)
});